import { inject } from '@angular/core';
import { OryIamConfig } from '../../model';
import { OryApiService } from '../../api';
import { OryFlowBase } from '../base.flow';

/**
 * Base class for Ory Kratos identity and authentication flows.
 * 
 * Provides access to the Kratos API client and configuration.
 */
export abstract class OryKratosBaseFlow extends OryFlowBase {
  protected readonly config = inject(OryIamConfig).base;
  protected readonly iamApi = inject(OryApiService).api;
}

